/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./CustomWidgetMapping.vue?vue&type=template&id=ea17ac5e&scoped=true&"
import script from "./CustomWidgetMapping.vue?vue&type=script&lang=js&"
export * from "./CustomWidgetMapping.vue?vue&type=script&lang=js&"
import style0 from "./CustomWidgetMapping.vue?vue&type=style&index=0&id=ea17ac5e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea17ac5e",
  null
  
)

export default component.exports